/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-07-15 15:15:11
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-07-15 15:17:01
 * @FilePath: \ui\src\api\message.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { BASE_URL } from '../const'
import http from './index.ts'
export const getConversation = (): Promise<Object> => {
  return http.post(
    '/conversation/titles',
    { pageNo: 1, pageSize: 100 },
    {
      'Content-Type': 'application/json',
    }
  )
}
export const getConversationDetail = (
  conversationId: string
): Promise<Object> => {
  return http.get(`/conversation/messages/v2/${conversationId}`)
}
export const delConversation = async (
  conversationId: string
): Promise<Object> => {
  return http.delete(`/conversation/title/${conversationId}`)
}
